<template>
    <div :class="{ 'main': true, 'has-footer': isFooterRoute, [ $route.name.toLowerCase() + '-route' ]: true }">
        <transition v-on:enter="onLogoEnter" v-on:leave="onLogoLeave">
            <div class="lotto-logo" v-show="isLogoRoute"><img src="/static/img/logos/lotto.png" /></div>
        </transition>

        <div class="content">
            <slot></slot>
        </div>

        <transition v-on:enter="onFooterEnter" v-on:leave="onFooterLeave">
            <footer v-show="isFooterRoute">
                <div class="content-wrapper">
                    <img src="/static/img/logos/footer.png" />
                    <p class="disclaimer">Voor het organiseren van Lotto is aan Lotto bv vergunning verleend door de Kansspelautoriteit, trekking Laan van Hoornwijck 55 te Rijswijk.<br />Deelname vanaf 18 jaar. Als je aan deze actie meedoet, dan accepteer je onze <a @click="trackAv" :href="avLink" target="_blank">actievoorwaarden</a>. | <a @click="trackPrivacyClickout" href="https://www.nederlandseloterij.nl/privacy" target="_blank">Privacy Statement</a> Nederlandse Loterij</p>
                </div>
            </footer>
        </transition>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TweenMax } from '@/vendor';
    import { tracking } from '@/app/mixins';

    export default {
        mixins: [ tracking ],

        data()
        {
            return {
                logoRoutes: [ 'Landing', 'Naw', 'Explain', 'Game', 'LottoBase' ],
                footerRoutes: [ 'Landing', 'Naw', 'Thanks', 'LottoBase' ]
            };
        },

        computed: {
            isLogoRoute()
            {
                return this.logoRoutes.indexOf( this.$route.name ) >= 0;
            },

            isFooterRoute()
            {
                return this.footerRoutes.indexOf( this.$route.name ) >= 0;
            },

            partnerId()
            {
                return this.$store.getters[ 'quiz/id' ];
            },

            isVersion2()
            {
                return this.$store.getters.isVersion2;
            },

            avLink()
            {
                if( this.isVersion2 )
                {
                    return '/static/pdf/actievoorwaarden2.pdf';
                }
                else
                {
                    return '/static/pdf/actievoorwaarden.pdf';
                }
            }
        },

        mounted()
        {
        },

        methods: {
            trackPrivacyClickout()
            {
                this.trackEvent( 'Klik op link - Privacy Statement', 'Link tracking', 'Nieuw venster - Privacy Statement - https://www.nederlandseloterij.nl/privacy' );
            },
            trackAv()
            {
                this.trackEvent( 'Klik op link - Actievoorwaarden', 'Link tracking', window.location.origin + this.avLink );
            },
            onLogoEnter()
            {
                TweenMax.fromTo( '.lotto-logo', 0.3, { x: '-200px' }, { x: 0, delay: 0.1 });
            },
            onLogoLeave( el, done )
            {
                TweenMax.fromTo( '.lotto-logo', 0.3, { x: '0px' }, { x: '-200px', onComplete: done });
            },
            onFooterEnter()
            {
                // TweenMax.fromTo( 'footer .content-wrapper', 0.3, { y: '200px' }, { y: 0, delay: 0.1 });
                TweenMax.set( '.footer', { position: 'relative' });
                TweenMax.fromTo( 'footer', 0.3, { y: '200px' }, { y: 0, delay: 0.1 });
                TweenMax.to( '.main', 1, {
                    overflow: 'hidden',
                    onComplete: () =>
                    {
                        TweenMax.set( '.main', { overflow: 'visible' });
                    }
                });
                TweenMax.fromTo( 'footer', 0.3, { overflow: 'hidden' }, { overflow: 'visible', delay: 0.1 });
            },
            onFooterLeave( el, done )
            {
                TweenMax.set( 'footer', {
                    position: 'absolute',
                    bottom: '0',
                    overflow: 'hidden',
                    onComplete: () =>
                    {
                        done();
                        TweenMax.set( 'footer', { position: 'static', overflow: 'visible' });
                    }
                });

                // TweenMax.fromTo( 'footer .content-wrapper', 0.3, { y: '0px' }, {
                //     y: '200px',
                //     onComplete: () =>
                //     {
                //         done();
                //         TweenMax.set( 'footer', { position: 'static', overflow: 'visible' });
                //     }
                // });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/layouts/Simple.vue